import { notNull } from "@gap/utils/utils";
import { apiClient } from "api/trpc/trpc-client";
import { MainContainerStore } from "features/main/main-router/org-guard/main-container/MainContainerStore";
import { makeAutoObservable } from "mobx";
import { formHandler, FormHandlerConfig } from "reusable/mobx-store-utils/form-handlers/new/form-handler";
import CacheStore from "cache/CacheStore";
import VgcAnalytics from "analytics/VgcAnalytics";
import { VgcSelectClientModalProps } from "./VgcSelectClientModal";

interface VgcSelectClientModalStoreParams {
   mainContainerStore: MainContainerStore
   cacheStore: CacheStore
   source?: VgcSelectClientModalProps['source']
}

export default class VgcSelectClientModalStore {
   sp
   fields = {
      selectedClientId: ''
   }
   newClient: string = ''

   constructor(sp: VgcSelectClientModalStoreParams) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get formHandler() {
      return formHandler(this.fields, {
         selectedClientId: { type: 'string' },
      } satisfies FormHandlerConfig)
   }

   onClientSelectedHandler = (clientId: string) => {
      this.fields.selectedClientId = clientId
   }

   openCalculator = async () => {
      if (this.sp.source === 'getting-started-checklist') {
         VgcAnalytics.openVgcFromGettingStartedChecklist()
      } else {
         VgcAnalytics.openVgcFromMainMenu()
      }

      const client = notNull(this.sp.cacheStore.clientsCacheStore.findClient(this.fields.selectedClientId))
      let { clientOrgId } = client
      if (!clientOrgId) {
         // ensure client org has been created
         ({ org: { id: clientOrgId } } = await apiClient.advisor.ensureClientOrgExists.mutate({ advisorClientId: client.id }))
      }

      this.sp.mainContainerStore.menuComponentModal.state.close()
      this.sp.mainContainerStore.sp.routerStore.navigate(`vgc/${clientOrgId}`)
      return
   }
}
